import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from 'components/custom-ui/CustomModal';

export default function TestModal(props) {
    return (
      <CustomModal title="Test Modal" id="TestModal">
        <CustomModalContent className="">
  
        </CustomModalContent>
  
        <CustomModalFooter>
          <ModalCloseButton id="TestModal" />
          <ModalPrimaryButton text="Test" />
        </CustomModalFooter>
      </CustomModal>
    );
  }